import {ClassificationTypes} from '../CASB.types'

// DLP Config Types
export enum DLPState {
  OFF = 'OFF',
  MONITOR = 'MONITOR',
  BLOCK = 'BLOCK',
}

export interface DlpExceptionFormState {
  state: DLPState
  email: string
}

export interface DLPException {
  state: DLPState
}

export type DLPExceptionRecord = Record<string, DLPException>

export interface DLPExceptionsNode {
  exceptions: DLPExceptionRecord
}

export interface DLPMode extends DLPExceptionsNode {
  state: DLPState
  inheritsFromBase: boolean
}

export interface DLPModeData {
  mode: DLPMode
}

export interface GetDLPConfigResponse {
  data: DLPModeData
}

export interface UpdateDLPStatePayload {
  state: DLPState
}

export interface UpdateDLPInheritPayload {
  inheritsFromBase: boolean
}

export interface UpdateDLPRestrictionsPayload {
  mode: UpdateDLPStatePayload | UpdateDLPInheritPayload
}

export interface UpdateDLPExceptionsPayload {
  mode: DLPExceptionsNode
}

// DLP Bypass Types
export interface DLPBypassURL {
  name: string
  note: string
  updatedBy: string
  updatedAt: string
}

export interface DLPBypass {
  inheritsFromBase: boolean
  customUrls: DLPBypassURL[]
}

export interface DLPBypassData {
  bypass: DLPBypass
}

export interface GetDLPBypassResponse {
  data: DLPBypassData
}

export interface UpdateDLPBypassCustomUrlsPayload {
  customUrls: DLPBypassURL[]
}

export interface UpdateDLPBypassInheritPayload {
  inheritsFromBase: boolean
}

export interface UpdateDLPBypassPayload {
  data: {
    bypass: UpdateDLPBypassCustomUrlsPayload | UpdateDLPBypassInheritPayload
  }
}

// DLP Dopamine Types
export interface DLPDopamineData {
  dopamine: string
  classifications: ClassificationTypes[]
}

export interface DLPDopamineResponse {
  data: DLPDopamineData
}

// Context state
export interface DLPConfig {
  mode: DLPMode
  bypass: DLPBypass
}

export interface DLPBypassFormData {
  domain: string
  note: string
}
